import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";

const style = {
  divContainer: {
    alingItems: "center",
    display: "flex",
    justifyContent: "center",
  },
  divStyles: {
    position: "relative",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    display: "flex",
    alingItems: "center",
    justifyContent: "center",
    flexFlow: "column",
    outline: "none",
  },
  pStyle: {
    fontSize: "20",
    fontFamily: "Montserrat",
    marginTop: 35,
    fontWeight: 600,
    marginRight: 50,
    marginLeft: -40,
    width: 200,
  },
  divP: {
    width: "100%",
    display: "flex",
    alingItems: "center",
    justifyContent: "center",
  },
  logo: {
    marginTop: 50,
    position: "relative",
  },
};

const Floading = ({ open }) => {
  return (
    <div style={style.divContainer}>
      <Modal
        open={open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style.divStyles}>
          <div style={style.divP}>
            <img
              className="w-[100px] relative"
              src={require("../assets/images/logo-navbar.png")}
            />
          </div>
          <div>
            <div className="text-white w-full font-bold text-small grid place-items-center">
              <div className="w-[100px] grid place-items-center">Quédate</div>
              <div className="w-[100px] grid place-items-center">conFIADO</div>
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default Floading;
